const state = {
    protections: []
};

const mutations = {
    setProtections(state, value) {
        state.protections = value;
    },
};

const actions = {};

const getters = {
    protections: (state) => state.protections,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
